import React from 'react';
import { motion } from 'framer-motion';

// --- UPDATED SOLUTIONS ARRAY ---
const solutions = [
  {
    title: 'Water & Wastewater Treatment',
    pageUrl: 'cooling-tower-treatment', // Added for specific URL
    description: 'Covers mixing, oxidation (COD/BOD), biomass disintegration, ballast water, cooling towers, and rural handpump disinfection.',
    image: '/industry.jpeg',
    color: 'bg-yellow-600',
  },
  {
    title: 'Chemical Process Intensification',
    pageUrl: 'sewage-water-treatment', // Added for specific URL
    description: 'Applications in nanoparticle synthesis, polymerization, organic synthesis, and green chemical manufacturing.',
    image: '/cooling.jpeg',
    color: 'bg-purple-600',
  },
  {
    title: 'Emulsion Stability & Industrial Processing', // Removed leading space
    pageUrl: 'industrial-effluent-pre-treatment', // Added for specific URL
    description: 'Enhanced mixing, particle dispersion, and emulsion stability for paints, coatings, and chemicals.',
    image: '/pool.jpeg',
    color: 'bg-pink-600',
  },
  {
    title: 'Bioreactors & Fermentation',
    pageUrl: 'swimming-pool-water-treatment', // Added for specific URL
    description: 'Boosts oxygen transfer, mixing, and microbial activity for higher productivity.',
    image: '/lake.jpg',
    color: 'bg-green-600',
  },
  {
    title: 'Biogas Pre-Treatment', // Removed leading space
    pageUrl: 'lake-and-pond-rejuvenation', // Added for specific URL
    description: 'Biomass disintegration for 20–40% higher methane yield.',
    image: '/mbbr_soln.png',
    color: 'bg-teal-600',
  },
  {
    title: 'Edible Oil Refining', // Removed leading space
    pageUrl: 'handpump-water-disinfection', // Added for specific URL
    description: 'Cavitation-based degumming, neutralization & bleaching for cleaner, faster processing.',
    image: '/Handpump-Photoroom.png',
    color: 'bg-blue-600',
  },
  {
    title: 'Cosmetic Industry', // Removed leading space
    pageUrl: 'cosmetic', // Added for specific URL
    description: 'Efficient mixing, homogenization, solubilization, and emulsion formation.',
    image: '/lake.jpg',
    color: 'bg-green-600',
  },
];
// --- END OF UPDATES ---

const Solutions = () => {
  // --- REMOVED formatUrl FUNCTION ---

  // --- UPDATED handleCardClick ---
  const handleCardClick = (pageUrl) => { // Argument is now pageUrl
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn === 'true') {
      // Builds the URL directly from the pageUrl property
      window.location.href = `/solutions/${pageUrl}`;
    } else {
      window.location.href = '/auth';
    }
  };

  return (
    <section id="solutions" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Applications of Cavitation Technology
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {solutions.map((solution, index) => (
            <div
              key={solution.title}
              // --- UPDATED onClick to pass solution.pageUrl ---
              onClick={() => handleCardClick(solution.pageUrl)}
              className="cursor-pointer"
            >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -5 }}
                className="relative rounded-xl shadow-lg overflow-hidden group"
              >
                <img
                  src={solution.image}
                  T alt={solution.title}
                  className="w-full h-60 object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div
                  className={`absolute inset-0 flex flex-col justify-center items-center text-center px-4 transition-all duration-500 ${solution.color} bg-opacity-90 opacity-0 group-hover:opacity-100`}
                >
                  <h3 className="text-xl font-semibold text-white mb-2">
                    {solution.title}
                  </h3>
                  <p className="text-white mb-4">{solution.description}</p>
                  <span className="text-sm font-medium text-white underline">
                    Know more
                  </span>
                </div>
                <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-40 text-white text-xl font-bold transition-all duration-500 group-hover:opacity-0 p-4 text-center">
                  {solution.title}
                </div>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;